(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-itunes-coverflow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CLASSES = ['left-hidden', 'left', 'middle', 'right', 'right-hidden'];
    var CLASS_PREFIX = 'itunes-cflow__item--';

    function norm(s) {
      return String(s || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function slotForIndex(i, focus, n) {
      var rel = i - focus;
      if (rel < -2) return 'left-hidden';
      if (rel === -2) return 'left-hidden';
      if (rel === -1) return 'left';
      if (rel === 0) return 'middle';
      if (rel === 1) return 'right';
      return 'right-hidden';
    }

    function applyFocus(items, focus) {
      var n = items.length;
      if (!n) return 0;
      focus = Math.max(0, Math.min(focus, n - 1));
      for (var i = 0; i < n; i++) {
        var el = items[i];
        var slot = slotForIndex(i, focus, n);
        for (var c = 0; c < CLASSES.length; c++) {
          el.classList.remove(CLASS_PREFIX + CLASSES[c]);
        }
        el.classList.add(CLASS_PREFIX + slot);
      }
      return focus;
    }

    function initPanel(panel, root) {
      var items = [].slice.call(panel.querySelectorAll('[data-itunes-cflow-item]'));
      if (!items.length) return;

      var stage = panel.querySelector('[data-itunes-cflow-stage]');
      var stageWrap = panel.querySelector('[data-itunes-cflow-stage-wrap]');
      var range = panel.querySelector('[data-itunes-cflow-range]');
      var search = panel.querySelector('[data-itunes-cflow-search]');
      var searchBtn = panel.querySelector('[data-itunes-cflow-search-btn]');
      var feedback = panel.querySelector('[data-itunes-cflow-feedback]');
      var prev = panel.querySelector('[data-itunes-cflow-prev]');
      var next = panel.querySelector('[data-itunes-cflow-next]');

      var focus = 0;
      var dragStartX = 0;
      var dragStartY = 0;
      var dragging = false;
      var moved = false;
      var suppressStageClick = false;
      var wheelAccum = 0;
      var wheelIdleTimer = null;
      var rangeSync = false;
      var autoTimer = null;

      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var autoplayMs = parseInt(root.getAttribute('data-autoplay-ms') || '5000', 10) || 5000;

      function setFeedback(msg, state) {
        if (!feedback) return;
        if (!msg) {
          feedback.hidden = true;
          feedback.textContent = '';
          feedback.removeAttribute('data-state');
          return;
        }
        feedback.hidden = false;
        feedback.textContent = msg;
        if (state) feedback.setAttribute('data-state', state);
        else feedback.removeAttribute('data-state');
      }

      function syncRangeFill() {
        if (!range) return;
        var min = parseFloat(range.min);
        var max = parseFloat(range.max);
        var val = parseFloat(range.value);
        if (isNaN(min)) min = 0;
        if (isNaN(max)) max = 0;
        if (isNaN(val)) val = min;
        var pct;
        if (max <= min) {
          pct = 100;
        } else {
          pct = ((val - min) / (max - min)) * 100;
        }
        range.style.setProperty('--itunes-range-pct', String(pct));
      }

      function syncRange() {
        if (!range) return;
        var max = items.length - 1;
        range.min = '0';
        range.max = String(max);
        rangeSync = true;
        range.value = String(focus);
        rangeSync = false;
        range.setAttribute('aria-valuemin', '0');
        range.setAttribute('aria-valuemax', String(max));
        range.setAttribute('aria-valuenow', String(focus));
        syncRangeFill();
      }

      function go(delta) {
        var n = items.length;
        focus = applyFocus(items, focus + delta);
        syncRange();
        setFeedback('');
      }

      function goTo(index) {
        focus = applyFocus(items, index);
        syncRange();
        setFeedback('');
      }

      function findSearchIndex(q) {
        var query = norm(q);
        if (!query) return -1;
        for (var i = 0; i < items.length; i++) {
          var el = items[i];
          var t = norm(el.getAttribute('data-title') || '');
          var sku = norm(el.getAttribute('data-sku') || '');
          if (t.indexOf(query) !== -1 || query.indexOf(t) !== -1) return i;
          if (sku && (sku.indexOf(query) !== -1 || query.indexOf(sku) !== -1)) return i;
        }
        return -1;
      }

      function doSearch() {
        if (!search) return;
        var idx = findSearchIndex(search.value);
        if (idx >= 0) {
          goTo(idx);
          setFeedback('');
        } else {
          setFeedback('No matching product.', 'error');
        }
      }

      function stopAutoplay() {
        if (autoTimer) {
          clearInterval(autoTimer);
          autoTimer = null;
        }
      }

      function startAutoplay() {
        stopAutoplay();
        if (!autoplay || items.length < 2) return;
        var hidden =
          panel.hidden || (panel.classList && panel.classList.contains('itunes-cflow__panel--hidden'));
        if (hidden) return;
        autoTimer = setInterval(function () {
          if (focus >= items.length - 1) goTo(0);
          else go(1);
        }, autoplayMs);
      }

      var initialFocus = Math.floor((items.length - 1) / 2);
      focus = applyFocus(items, initialFocus);
      syncRange();

      if (prev) prev.addEventListener('click', function () { stopAutoplay(); go(-1); });
      if (next) next.addEventListener('click', function () { stopAutoplay(); go(1); });

      if (searchBtn) searchBtn.addEventListener('click', doSearch);
      if (search) {
        search.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            doSearch();
          }
        });
      }

      if (range) {
        range.addEventListener('input', function () {
          if (rangeSync) return;
          stopAutoplay();
          var v = parseInt(range.value, 10);
          if (!isNaN(v)) goTo(v);
        });
      }

      if (stageWrap) {
        stageWrap.addEventListener('mouseenter', stopAutoplay);
        stageWrap.addEventListener('mouseleave', startAutoplay);
        stageWrap.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            stopAutoplay();
            go(-1);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            stopAutoplay();
            go(1);
          }
        });
      }

      items.forEach(function (item) {
        var link = item.querySelector('a.itunes-cflow__card');
        if (!link) return;
        link.addEventListener(
          'click',
          function (e) {
            if (suppressStageClick) {
              e.preventDefault();
              e.stopPropagation();
              suppressStageClick = false;
              return;
            }
            if (e.defaultPrevented) return;
            if (e.button !== 0) return;
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
            var href = link.getAttribute('href');
            if (!href || href === '#') return;
            e.preventDefault();
            e.stopPropagation();
            window.location.assign(href);
          },
          false
        );
      });

      if (stage) {
        stage.addEventListener('focusin', function () {
          suppressStageClick = false;
        });
        stage.addEventListener('pointerdown', function (e) {
          if (e.button !== 0 && e.pointerType === 'mouse') return;
          /* Include drags starting on product cards; swipe uses horizontal delta, tap still opens product */
          suppressStageClick = false;
          dragging = true;
          moved = false;
          dragStartX = e.clientX;
          dragStartY = e.clientY;
          stage.classList.add('itunes-cflow__stage--dragging');
          /* Do not setPointerCapture: it retargets events to the stage and breaks clicks on <a> (esp. mobile). */
        });
        stage.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          if (Math.abs(e.clientX - dragStartX) > 8 || Math.abs(e.clientY - dragStartY) > 8) moved = true;
        });
        stage.addEventListener('pointerup', function (e) {
          if (!dragging) return;
          dragging = false;
          stage.classList.remove('itunes-cflow__stage--dragging');
          var dx = e.clientX - dragStartX;
          var dy = e.clientY - dragStartY;
          if (moved && Math.abs(dx) > 40 && Math.abs(dx) >= Math.abs(dy)) {
            stopAutoplay();
            suppressStageClick = true;
            if (dx < 0) go(1);
            else go(-1);
          } else {
            suppressStageClick = false;
          }
        });
        stage.addEventListener('pointercancel', function () {
          dragging = false;
          stage.classList.remove('itunes-cflow__stage--dragging');
        });
      }

      /* Trackpad / mouse horizontal scroll (and Shift + vertical wheel) advances the carousel */
      if (stageWrap && items.length > 1) {
        stageWrap.addEventListener(
          'wheel',
          function (e) {
            var dx = e.deltaX;
            if (e.shiftKey) dx += e.deltaY;
            if (Math.abs(dx) < Math.abs(e.deltaY) && !e.shiftKey) return;
            if (Math.abs(dx) < 4) return;
            e.preventDefault();
            wheelAccum += dx;
            if (wheelIdleTimer) clearTimeout(wheelIdleTimer);
            wheelIdleTimer = setTimeout(function () {
              wheelAccum = 0;
              wheelIdleTimer = null;
            }, 180);
            if (Math.abs(wheelAccum) < 72) return;
            stopAutoplay();
            if (wheelAccum > 0) go(1);
            else go(-1);
            wheelAccum = 0;
          },
          { passive: false }
        );
      }

      panel.__itunesStopAutoplay = stopAutoplay;
      panel.__itunesStartAutoplay = startAutoplay;

      startAutoplay();
    }

    function panelIsHidden(panel) {
      return panel.hidden || (panel.classList && panel.classList.contains('itunes-cflow__panel--hidden'));
    }

    function activateVisiblePanel(root) {
      [].slice.call(root.querySelectorAll('[data-itunes-cflow-panel]')).forEach(function (p) {
        if (p.__itunesStopAutoplay) p.__itunesStopAutoplay();
      });
      [].slice.call(root.querySelectorAll('[data-itunes-cflow-panel]')).forEach(function (p) {
        if (panelIsHidden(p)) return;
        if (p.dataset.itunesPanelReady !== '1') {
          initPanel(p, root);
          p.dataset.itunesPanelReady = '1';
        } else if (p.__itunesStartAutoplay) {
          p.__itunesStartAutoplay();
        }
      });
    }

    function initRoot(root) {
      if (!root || root.dataset.itunesCflowBound === '1') return;
      root.dataset.itunesCflowBound = '1';

      var tabs = [].slice.call(root.querySelectorAll('[data-itunes-cflow-tab]'));
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-panel-id');
          if (!id) return;
          [].slice.call(root.querySelectorAll('[data-itunes-cflow-panel]')).forEach(function (p) {
            if (p.__itunesStopAutoplay) p.__itunesStopAutoplay();
          });
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('itunes-cflow__tab--active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          [].slice.call(root.querySelectorAll('[data-itunes-cflow-panel]')).forEach(function (p) {
            var show = p.id === id;
            p.classList.toggle('itunes-cflow__panel--hidden', !show);
            p.hidden = !show;
          });
          activateVisiblePanel(root);
        });
      });

      [].slice.call(root.querySelectorAll('[data-itunes-cflow-panel]')).forEach(function (p) {
        if (!panelIsHidden(p)) {
          initPanel(p, root);
          p.dataset.itunesPanelReady = '1';
        }
      });
    }

    document.querySelectorAll('[data-itunes-cflow-root]').forEach(initRoot);
    document.addEventListener('shopify:section:load', function (ev) {
      var r = ev.target && ev.target.querySelector && ev.target.querySelector('[data-itunes-cflow-root]');
      if (r) initRoot(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
